import { Button } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router";
import Iconify from "src/components/Iconify";
import Translate from "src/components/translate";
import buildPath from "src/utils/build-path";
import objectToQueryString from "src/utils/object-to-query-string";
import squashPathAndQueryString from "src/utils/squash-path-and-query-string";

const GoogleOAuthButton = ({ buttonLabel, plan }) => {
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: (codeResponse) =>
      navigate(
        squashPathAndQueryString(
          buildPath("/auth/O-auth", codeResponse.access_token),
          objectToQueryString({ plan })
        )
      ),
  });

  return (
    <>
      <Button
        startIcon={<Iconify icon="logos:google-icon" width={20} height={20} />}
        variant="outlined"
        fullWidth
        sx={{
          mt: 2,
          py: 1.25,
          borderRadius: "14px",
          fontWeight: 700,
          textTransform: "none",
          fontSize: "0.92rem",
          borderColor: (theme) => alpha(theme.palette.grey[500], 0.25),
          color: "text.primary",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            borderColor: "primary.main",
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
            transform: "translateY(-1px)",
          },
        }}
        onClick={login}
      >
        <Translate>{buttonLabel}</Translate>
      </Button>
    </>
  );
};

export default GoogleOAuthButton;
